<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/serve/02/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="z-n-y-j-z-c page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="z-n-y-j-z-c-content">
                            <auto-row class="max-size list-more flex-column">
                                <auto-col class="">
                                    <div class="list-icons flew-row-wrap">
                                        <auto-row class="list-item-icons" v-for="(cell,index2) of f_w_lists" :key="index2">
                                            <auto-col class="icon-info">
                                                <div style="margin: auto">
                                                    <img :src="cell.icon" class="icon max-size"  alt="">
                                                </div>
                                                <div class="text">{{cell.label}}</div>
                                                <div class="info-items">
                                                    <div class="title">{{cell.label}}</div>
                                                    <div class="txt">{{cell.txt}}</div>
                                                </div>
                                            </auto-col>
                                        </auto-row>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>-->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/serve/02/pic-1.png'),
                ],
                f_w_lists:[
                    {label:"智能枕", icon:require('@/assets/image/serve/02/01.png'),txt:'功能：监测人体在床的基础身理体征（心跳、呼吸）和在床活动状态设备放置于枕头（可多个枕头）下，和使用者不直接接触，记录数据准确，使用安全可靠。'},
                    {label:"褥疮防治床垫QDC-320", icon:require('@/assets/image/serve/02/02.png'),txt:'功能：(1)PVC材质，防水耐脏(2)双气道，交替式充/放气(3)低噪音设计(4)气条可单独拆卸，有效预防长期卧床压疮褥疮的发生！'},
                    {label:"远程智护睡眠检测带", icon:require('@/assets/image/serve/02/03.png'),txt:'功能：具有清醒状态，睡眠状态，心率异常，呼吸异常，离床报警，WiFi异常，设备断电七种状态，全方位照护'},
                    {label:"卫美恒bobby轮椅", icon:require('@/assets/image/serve/02/04.png'),txt:'功能：一键自动折叠；配置新手模式和语音提示功能，充分考虑高龄长者的操控友善度；越野全向轮适应多种地形；松手即停，SOS一键求助，安全可控，是老年及伤残等弱能群体的全新智慧出行解决方案。'},
                    {label:"助力步行辅助器", icon:require('@/assets/image/serve/02/05.png'),txt:'功能：可以让通过器械的支撑，让腿脚不方便的老人及 病人 等腿脚不灵活甚至失去行走能力的人能够自理，能够和正常人一样外出散步。'},
                    {label:"远程智护医疗血压计", icon:require('@/assets/image/serve/02/06.png'),txt:'功能：血压计内置物联网技术，血压测量结果会自动传输到云端及手机APP，真正实现远程照护，一起养成良好的血压数据管理习惯。'},
                    {label:"添康220五功能护理床", icon:require('@/assets/image/serve/02/07.png'),txt:'功能：电动护理床'},
                    {label:"T007红外测温手机", icon:require('@/assets/image/serve/02/08.png'),txt:'功能：红外精准测温/双卫星九重精准定位/一键电话呼叫。'},
                    {label:"S7Pro智能照护手环", icon:require('@/assets/image/serve/02/09.png'),txt:'功能：全程通 S7pro智能手环运动腕表 蓝牙通话移动支付 血压心率血氧健康监测。'},
                    {label:"智能床", icon:require('@/assets/image/serve/02/10.png'),txt:'功能：智能传感技术为基础，具有数据采集监测、存储传输、基于感知数据的处置调整、远程控制一种或多种功能的可调节的床具。'},
                    {label:"智能摄像头", icon:require('@/assets/image/serve/02/11.png'),txt:'功能：手机电脑无线远程wifi/4G智能室内室外防雨夜视摄像头、批发货源摄像头;4G摄像头;插座供电摄像头;无线摄像头。'},
                    {label:"S5智能照护手环", icon:require('@/assets/image/serve/02/12.png'),txt:'功能：老人呼叫器性价比高,易操作,待机时间长,老人防走失智能手环,智慧养老平台。'},
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(n){
        background-color:#ffffff;
    }
    .page-content-box{
        overflow:hidden;
        /*min-height:500px;*/
    }
    .z-n-y-j-z-c .z-n-y-j-z-c-content{
        margin-top:5px;
    }


    .z-n-y-j-z-c .list .info .text{
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        margin-left:40px;
    }



    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
        /*margin:155px 0 190px 0;*/
        margin:155px 0 90px 0;
    }


    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons{
        text-align: center;
        width:calc(100% + 40px);
        margin-left: -20px;
    }

    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
        width:calc(33.33% - 40px);
        text-align: center;
        transition: all .3s;
        margin: 0 20px 48px;
        border-radius: 8px;
        border: 1px solid #979797;

    }

    .icon-info{
        display: flex;
        flex-flow: column nowrap;
        padding:30px 0;
        width:100%;
        max-height: 400px;

        height:100%;
        position:relative;
        overflow: hidden;
        background:linear-gradient(90deg,#2FA8D0,#2FA8D0);
        background-repeat: no-repeat;
        background-position:center top;
        background-size:100% 0;
        transition: all .3s;
    }

    .icon-info:hover{
        background-size:100% 100%;
    }
    .icon-info:hover .info-items{
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        height: 100%;
        max-height: 400px;
    }

    .info-items{
        display: none;
        padding: 0 40px;
        overflow: auto;
        height: 100%;
        max-height: 400px;
    }

    .info-items .title{
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
    }

    .info-items .txt{
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        margin-top:40px;
    }

    .icon-info .icon{
        margin: 0 auto;
        max-height: 270px;
    }
    .icon-info .text{
        font-size: 20px;
        color:#333333;
        padding-top:40px;
        padding-bottom:10px;
    }

    .icon-info:hover .icon{
        display:none;
    }
    .icon-info:hover .text{
        display:none;
    }



    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){

    }

    @media screen and (max-width: 1200px){
        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            margin:120px 0 60px 0;
        }
        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
            width:calc(50% - 40px);
            text-align: center;
            transition: all .3s;
            margin: 0 20px 48px;
            border-radius: 8px;
            border: 1px solid #979797;
        }

        .list-icons{
            display: flex;
            flex-flow: row  wrap;
        }
    }

    @media screen and (max-width: 960px){
        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            margin:80px 0 50px 0;
        }

    }

    @media screen and (max-width: 760px){
        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            margin:60px 0 30px 0;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
            width:calc(100% - 40px);
            text-align: center;
            transition: all .3s;
            margin: 0 20px 48px;
            border-radius: 8px;
            border: 1px solid #979797;
        }

        .list-icons{
            display: flex;
            flex-flow: row  wrap;
        }

    }
</style>
